import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CONFIG } from '../../config'
import { useAuth } from '../../contexts/AuthContext'
import { PartnerModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'
import { useFetch } from '../useFetch'

export function useAcceptPartner() {
  const { authInfo } = useAuth()
  const { t } = useTranslation(['partners', 'exceptions'])
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const acceptPartner = async (partnerId: number) => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const partner = await patcher<PartnerModel>(
        `${CONFIG.BOUNCE_API}/api/v1/partners/${partnerId}/accept`
      )
      setSuccess(t('partners:partners.hook.successfully-accepted'))
      return partner
    } catch (caughtError) {
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return null
    } finally {
      setLoading(false)
    }
  }

  return { acceptPartner, loading, error, success, resetState }
}
